//
// http://stackoverflow.com/questions/5327420/overriding-jquery-find-function-to-provide-extra-functionality
//
(function () {
    // Store a reference to the original remove method.
    var originalFindFunction = jQuery.fn.find;

    // Define overriding method.
    jQuery.fn.find = function (selector) {
        var results, newSelectorArray;
        // Log that we are calling the overridden function.

        if (typeof (selector) == "string") {
            newSelectorArray = [];
            if (selector.indexOf("inp:") >= 0) {
                selector = selector.substring(4, selector.length);
                newSelectorArray.push("[xname='inp" + selector + "']");
                results = originalFindFunction.apply(this, newSelectorArray);
            } else if (selector.indexOf("div:") >= 0) {
                selector = selector.substring(4, selector.length);
                newSelectorArray.push("[xid='div" + selector + "']");
                results = originalFindFunction.apply(this, newSelectorArray);
            }
        }

        if (results === undefined) {
            // then execute the original method
            results = originalFindFunction.apply(this, arguments);
        }
        return results;
    };
})();